import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PropertyToSendPage } from './property-to-send.page';

const routes: Routes = [
  {
    path: '',
    component: PropertyToSendPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PropertyToSendRoutingModule { }
